<p-dialog
		[(visible)]="visibleLocal"
		[draggable]="true"
		[modal]="true"
		(onHide)="fermerModal()"
		styleClass="modale-medium"
		[closable]="true"
		[style]="{
		'max-width': '900px',
		'max-height': '800px',
		'width': '100%',
		'height': '100%'
		}">
	<alert [nom]="NOM_ALERTE_DETAIl_RESERVATION_MODAL"></alert>

	<div class="detail-reservation-modal-container">
		<div class="information-reservation">
			<span class="label-information-reservation">{{ 'ACCUEIL.DETAIL_RESERVATION.DATE_RESERVATION' | translate }}</span>
			<span class="valeur-information-reservation">{{ formattageDateSansHeurePourAffichage(reservation().date) }}</span>
		</div>
		<div class="information-reservation">
			<span class="label-information-reservation">{{ 'ACCUEIL.DETAIL_RESERVATION.DUREE_RESERVATION' | translate }}</span>
			<span class="valeur-information-reservation">{{ reservation().duree.designation }}</span>
		</div>
		<div class="information-reservation">
			<span class="label-information-reservation">{{ 'ACCUEIL.DETAIL_RESERVATION.NOM_BUREAU' | translate }}</span>
			<span class="valeur-information-reservation date-evenement">{{ reservation().nomBureau }}</span>
		</div>
		<div class="information-reservation">
			<span class="label-information-reservation">{{ 'ACCUEIL.DETAIL_RESERVATION.NOM_ILOT' | translate }}</span>
			<div
					class="information-ilot"
					[style.background-color]="reservation().couleurIlot">
				<span
						class="valeur-information-reservation date-evenement">{{ reservation().nomIlot }}
				</span>
			</div>
		</div>
		<div class="affichage-ilot" #containerAffichageIlot>
			@if (loadingConstructionIlot()) {
				<div class="spinner">
					<div class="app-spinner"></div>
				</div>
			} @else {
				@if (isNotNullOrUndefined(ilot())) {
					<app-grid-ilots
							[ilots]="[ilot()]"
							[readonly]="true"
							[longueurParent]="longueurParent()"
							[hauteurParent]="hauteurParent()"
							[bureauIdCourant]="reservation().bureauId"
							[estAffichagePlusieursIlots]="false"
							[estAffichageVertical]="false"
							[labelHaut]="labelHaut()"
							[labelBas]="labelBas()"
							[labelDroite]="labelDroite()"
							[labelGauche]="labelGauche()"
							[estAfficherLabelIlot]="false"/>
				}
			}
		</div>
	</div>
	<p-footer>
		@if (estAfficherBoutonAnnulation()) {
			<span class="btn-annuler-reservation">
				<p-button
						[label]="'ACCUEIL.DETAIL_RESERVATION.BTN_ANNULER_RESERVATION' | translate"
						type="button"
						icon="pi pi-times-circle"
						[loading]="loadingAnnulation()"
						(click)="annulerReservation()"/>
			</span>
		}
		<p-button
				[label]="'GLOBAL.BTN_FERMER' | translate"
				type="button"
				styleClass="p-button-link"
				(click)="fermerModal()"/>
	</p-footer>
</p-dialog>
